/**
 *
 * VideoEmbed
 *
 */

import React, { memo, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import {
  Modal,
  ModalContent,
  Conditional,
  Button,
  Dropdown,
  Embed,
  Image,
} from '@cashfree-intl/coherent';

import { ACTION_REQUIRED } from 'containers/Disputes/constants';
import {
  DISPUTES,
  DISPUTES_INFO_DOC_LINK,
  TRANSACTIONS,
  VIDEO_EMBEDS,
} from 'utils/constants';
import useClickOutside from 'utils/hooks';
import EVENTS from 'constants/analytics';
import Analytics from 'utils/analytics';
import youtubeIcon from 'images/youtube.svg';
import CustomIcons from '../CustomIcons';
function VideoEmbed({ embedKey, activeTab }) {
  const [modalData, resetModalData] = useState(null);
  const modalRef = useRef(null);

  const closeModal = () => resetModalData(null);

  useClickOutside(modalRef, closeModal);

  let embedObj = VIDEO_EMBEDS[embedKey];

  if (embedObj && !Array.isArray(embedObj)) embedObj = embedObj[activeTab];

  const showVideoEmbed = data => () => {
    resetModalData(data);
    if (EVENTS.VIDEO_EMBED[embedKey]) {
      if (EVENTS.VIDEO_EMBED[embedKey][activeTab])
        Analytics.track(EVENTS.VIDEO_EMBED[embedKey][activeTab]);
      else Analytics.track(EVENTS.VIDEO_EMBED[embedKey]);
    }
  };

  const onDropdownChange = (e, { value }) => {
    showVideoEmbed(JSON.parse(value))();
  };

  const renderEmbed = !!(embedObj && embedObj.length);

  return renderEmbed ? (
    <div className="video-embed-wrapper">
      <Conditional if={activeTab !== DISPUTES}>
        <Image src={youtubeIcon} inline spaced="right" />
      </Conditional>
      <Conditional if={embedObj.length === 1}>
        {activeTab === DISPUTES ? (
          <a
            href={DISPUTES_INFO_DOC_LINK}
            target="_blank"
            className="dispute-docs-link"
            onClick={() =>
              Analytics.track(
                EVENTS[TRANSACTIONS][DISPUTES][ACTION_REQUIRED]
                  .DISPUTE_INFO_DOCS_CLICK,
              )
            }
          >
            Know more about the new disputes tab
          </a>
        ) : (
          <Button
            link
            size="small"
            onClick={showVideoEmbed(embedObj[0])}
            className="video-embed-cta"
          >
            {embedObj[0].title}
          </Button>
        )}
      </Conditional>
      <Conditional if={embedObj.length > 1}>
        <Dropdown
          trigger={
            <span className="mr-1 small-text text-primary w-600">
              View Help Videos
            </span>
          }
          selectOnBlur={false}
          direction="left"
          options={embedObj.map(obj => ({
            key: obj.url,
            text: obj.title,
            value: JSON.stringify({ ...obj }),
          }))}
          icon={<CustomIcons componentName="CHEVRONDOWN" />}
          onChange={onDropdownChange}
        />
      </Conditional>
      {modalData ? (
        <Modal open className="video-embed-modal" ref={modalRef}>
          <ModalContent>
            <Embed
              active
              placeholder={modalData.title}
              url={modalData.url}
              autoplay={false}
              iframe={{
                allowFullScreen: true,
              }}
            />
          </ModalContent>
        </Modal>
      ) : null}
    </div>
  ) : null;
}

VideoEmbed.propTypes = {
  embedKey: PropTypes.string.isRequired,
  activeTab: PropTypes.string,
};

export default memo(VideoEmbed);
